import React, { useContext, useEffect, useMemo, useState } from "react";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import { RiShareFill } from "react-icons/ri";
import {
  addToWishList,
  removeFromWishList,
} from "@/utils/wishlist/addAndRemoveWishlist";
import toast from "react-hot-toast";
import { AppContext } from "@/contexts/appContexts";
import { useSession } from "next-auth/react";
import CompareContext from "@/contexts/compare/compare-context";
import { useTranslation } from "react-i18next";
import ShareModal from "../share/share-modal";
import { MdOutlineCompare } from "react-icons/md";

const ActionButtons = ({ product }) => {
  const {
    t,
    i18n: { locale },
  } = useTranslation("common");

  const [open, setOpen] = useState(false);
  const [config, setConfig] = useState({ canonical: "", url: "" });
  const shareDetails = {
    url: config.url,
    title: product?.name,
    description: product?.description,
  };

  useEffect(() => {
    const canonical = document.querySelector("link[rel=canonical]");
    const url = canonical ? canonical.href : document.location.href;
    setConfig({ canonical, url });
  }, []);

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share(shareDetails);
      } catch (error) {}
    } else {
      setOpen(true);
    }
  };

  const compareCtx = useContext(CompareContext);
  const [inCompare, setInCompare] = useState(false);
  useEffect(() => {
    const existingProduct = compareCtx.compareProducts.find(
      (compareProduct) => compareProduct.sku === product.sku
    );
    setInCompare(!!existingProduct);
  }, [product?.sku, compareCtx?.compareProducts]);

  const { wishList, setwishList } = useContext(AppContext);
  const foundItem = useMemo(() => {
    return product && wishList
      ? wishList.find((item) => item.sku === product.sku)
      : null;
  }, [wishList, product]);

  const [isFav, setIsFav] = useState(!!foundItem);
  const { data: session } = useSession();
  const customer_id_session = session?.user?.id;

  const toggleFavorite = () => {
    if (isFav) {
      removeFromWishList(product, wishList, setwishList, customer_id_session);
      toast.success(
        locale === "ar" ? "تمت الإزالة من المفضلة" : "Removed from Favorites"
      );
    } else {
      addToWishList(product, wishList, setwishList, customer_id_session);
      toast.success(
        locale === "ar" ? "تمت الإضافة إلى المفضلة" : "Added to Favorites"
      );
    }
    setIsFav(!isFav);
  };

  return (
    <div className="relative flex items-center justify-center mb-4 gap-7">
      {/* Compare Button */}
      <button
        className="flex items-center justify-center gap-2 bg-gray-100 rounded-full size-10"
        onClick={() => {
          if (compareCtx.compareProducts.length >= 4 && !inCompare) {
            return toast.error(
              t(
                "Maximum 4 products can be compared, please remove one to add another."
              )
            );
          }
          compareCtx.addProductToCompare(product);
        }}
      >
        <MdOutlineCompare className={`${inCompare ? "text-red" : ""}`} />
      </button>

      {/* Share Button */}
      <button
        className="flex items-center justify-center gap-2 bg-gray-100 rounded-full size-10"
        onClick={handleShare}
      >
        <RiShareFill />
      </button>
      <ShareModal
        {...{ url: config.url, title: product?.title, t, open, setOpen }}
      />

      {/* Favorite Button */}
      <button
        className="flex items-center justify-center gap-2 bg-gray-100 rounded-full size-10"
        onClick={toggleFavorite}
      >
        {!isFav ? (
          <AiOutlineHeart size={20} />
        ) : (
          <AiFillHeart className="text-red" size={20} />
        )}
      </button>
    </div>
  );
};

export default ActionButtons;
